module.exports = __webpack_public_path__ + "media/img/home/animate/item3-844d82106893c7779c5f69a3ed0957e5.svg";